/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OneSpecialChar/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaArrowRightAlt from 'DesignSystem/Svgs/TysiaArrowRightAlt/index'
import TysiaInputHelp from 'DesignSystem/TysiaInput/TysiaInputHelp/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function OneSpecialChar({
  children,
  viewPath = "/App/Auth/ResetPasswordConfirm/PasswordRules/OneSpecialChar",
  isInvalid
  
}) {
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let resetPasswordConfirmPasswordIsValidData = fromData.useDataIsValid({ viewPath,
context: 'reset_password_confirm',
path: 'password',
validate: fromValidate.password_one_special_char,
required: true,
})
  return (<React.Fragment
>
<div
  data-testid="OneSpecialChar.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaArrowRightAlt
  viewPath={`${viewPath}/TysiaArrowRightAlt`}
 width={16}
 height={16}
 fill2={dtColorsNeutral900}
 marginRight={4}
/>
<TysiaInputHelp
  viewPath={`${viewPath}/TysiaInputHelp`}
 text="One special character !@&"
 marginTop={0}
 data="reset_password_confirm.password"
 validate="/Data/validate.js password_one_special_char"
 required={true}
 invalid={!resetPasswordConfirmPasswordIsValidData}
/>
</div>
{children}
</React.Fragment>)
}